import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Redirect } from 'react-router-dom';

import {
  Firebase,
  currentUserIsAdmin,
  getFourboxCategories,
  getIcon,
  getOptionValueForSelect,
  sellingCompetencies,
} from '../../util';

import {
  getReportingAndEvaluationPeriodsForThisYear,
  getCurrentReportingAndEvaluationYear
} from '../../util/quarters';

import { OrganizationRef } from '../../util/refs';

import SettingsCustomSidebar from './settingsCustomSidebar';

import { Page, Switch } from '../shared';

import Select from 'react-select';

import { UpdateGoalsModal } from '../modals';

import { beginEditingGoals, endEditingGoals } from '../../actions/goals';

import Dropzone from 'react-dropzone';

import AssessmentSetupSection from './sections/assessmentSetupSection';
import IntegrationsSection from './sections/integrationsSection';
import ManageExpertiseSection from './sections/manageExpertiseSection';

class SettingsPage extends Component {

  state = {
    currentView: 'general',
    uploading: false,
    uploadProgress: 0,
    configuringGoals: false,
    pageMessage: null,
    editingGoal: null,
  }

  componentDidUpdate(){
    const pageTab = this.props.match.params.pageTab || 'general';

    if(this.state.currentView !== pageTab){
      this.setState({
        currentView: pageTab,
      });
    }
  }

  componentWillReceiveProps(nextProps){
    console.log('settings nextProps: ', nextProps);
  }

  //TODO abstract this out
  onDrop(acceptedFiles, rejectedFiles){
    //for accepted files, upload them
    _.each(acceptedFiles, file => {
      this.uploadFile(file);
    });
  }

  clearUploadProgress(){
    this.setState({
      uploading: false,
      uploadProgress: 0,
    });
  }

  onFileUploadSuccess(upload){
    //save logo to org object
    OrganizationRef().update({
      logoUrl: upload.downloadURL
    });
    setTimeout(this.clearUploadProgress.bind(this), 500);
  }

  uploadFile(file){

    this.setState({
      uploading: true
    });

    const storage = Firebase.storage();
    const fileUploadPath = this.props.organization._id + '/uploads/' + file.name;

    const uploadTask = storage.ref(fileUploadPath).put(file);
    const successFunction = this.onFileUploadSuccess.bind(this);

    //https://firebase.google.com/docs/storage/web/upload-files
    uploadTask.on('state_changed', snap => {

      const uploadProgress = (snap.bytesTransferred / snap.totalBytes) * 100;

      this.setState({
        uploadProgress
      });

      console.log('upload progress: ', uploadProgress);
    }, err => {
      //error
      this.setState({
        uploadError: err
      });
    }, () => {
      //success
      const lastModified = uploadTask.snap;

      uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        uploadTask.snapshot.ref.getMetadata().then(metaData => {
          successFunction({
            fileName: file.name,
            fileSize: file.size,
            ref: fileUploadPath,
            lastModified: metaData.timeCreated,
            downloadURL,
          });
        });
      });
    });
  }

  toggleCompetenciesEnabled(){
    const currentValue = this.props.organization.competenciesEnabled ? this.props.organization.competenciesEnabled : false;

    OrganizationRef().update({
      competenciesEnabled: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  toggleCustomGoals(){

    const currentValue = this.props.organization.customGoalsEnabled ? this.props.organization.customGoalsEnabled : false;

    OrganizationRef().update({
      customGoalsEnabled: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  toggleNotificationsPaused(){
    const currentValue = this.props.organization.notificationsPaused ? this.props.organization.notificationsPaused : false;

    OrganizationRef().update({
      notificationsPaused: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  toggleForecastingRangeDisabled(){
    const currentValue = this.props.organization.forecastingRangeDisabled ? this.props.organization.forecastingRangeDisabled : false;

    OrganizationRef().update({
      forecastingRangeDisabled: !currentValue
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  renderConfigureGoalsButton(){
    const { sprintGoals } = this.props.organization || {};

    return (
      <div>
        <button onClick={() => { this.props.beginEditingGoals(sprintGoals); } } className="button primary">Configure Goals</button>
      </div>
    );
  }

  toggleProfileOption(optionName, optionValue){
    //profileOptions
    OrganizationRef().update({
      profileOptions: {
        ...this.props.organization.profileOptions,
        [optionName]: optionValue
      }
    }).then(() => {
      this.onSettingUpdated();
    });
  }

  updateOrganizationProp(prop = {}, skipConfirmation = false){
    OrganizationRef().update(prop).then(() => {
      if(!skipConfirmation){
        this.onSettingUpdated();
      }
    });
  }
  updateOrganizationProps(props = {}, skipConfirmation = false){
    OrganizationRef().update(props).then(() => {
      if(!skipConfirmation){
        this.onSettingUpdated();
      }
    });
  }

  renderReportingOptions(){
    const {
      reportsRequireRole
    } = this.props.organization || {};

    const currentRoleValue = reportsRequireRole || 'admin';

    const options = [{
      value: 'admin',
      label: 'Admin'
    },{
      value: 'salesleader',
      label: 'Admin + Salesleader'
    }];

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '20px', padding: 0}}>

        <div className="form-group">
          <div className="input-group half-width">
            <label>Viewing Reports Require Role...</label>
            <Select
              placeholder="..."
              classNamePrefix={'react-select'}
              className='react-select-container reports-require-role'
              value={getOptionValueForSelect(options, currentRoleValue)}
              options={options}
              onChange={(option) => { this.updateOrganizationProp({ reportsRequireRole: option.value }); }}
              isSearchable={false}
            />
          </div>
        </div>
      </form>
    )
  }

  renderDisabledFunctionalityOptions(){
    const {
      dealIQDisabled,
      coachingIQDisabled,
      talentIQDisabled
    } = this.props.organization || {};

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '20px', padding: 0}}>

        <div className="form-group">

          <div className="input-group third-width switch-input-group">
            <label>Disable Deal Intelligence</label>
            <Switch
              id="some-switch"
              checked={dealIQDisabled || false}
              onChange={checked => { this.updateOrganizationProp( {dealIQDisabled: checked} ); } }
            />
          </div>

          <div className="input-group third-width switch-input-group">
            <label>Disable Coaching Intelligence</label>
            <Switch
              id="some-switch"
              checked={coachingIQDisabled || false}
              onChange={checked => { this.updateOrganizationProp( {coachingIQDisabled: checked} ); } }
            />
          </div>

          <div className="input-group third-width switch-input-group">
            <label>Disable Talent Intelligence</label>
            <Switch
              id="some-switch"
              checked={talentIQDisabled || false}
              onChange={checked => { this.updateOrganizationProp( {talentIQDisabled: checked} ); } }
            />
          </div>

        </div>

      </form>
    )
  }

  renderEmployeeProfileOptions(){
    const { tenureEnabled, educationEnabled, experienceEnabled, titleEnabled, genderEnabled } = ((this.props.organization || {}).profileOptions || {});

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '20px', padding: 0}}>

        <div className="form-group">

          <div className="input-group fifth-width switch-input-group">
            <label>Title</label>
            <Switch
              id="some-switch"
              checked={titleEnabled || false}
              onChange={checked => { this.toggleProfileOption('titleEnabled', checked); } }
            />
          </div>

          <div className="input-group fifth-width switch-input-group">
            <label>Tenure</label>
            <Switch
              id="some-switch"
              checked={tenureEnabled || false}
              onChange={checked => { this.toggleProfileOption('tenureEnabled', checked); } }
            />
          </div>

          <div className="input-group fifth-width switch-input-group">
            <label>Education</label>
            <Switch
              id="some-switch"
              checked={educationEnabled || false}
              onChange={checked => { this.toggleProfileOption('educationEnabled', checked); } }
            />
          </div>

          <div className="input-group fifth-width switch-input-group">
            <label>Prior Sales Experience</label>
            <Switch
              id="some-switch"
              checked={experienceEnabled || false}
              onChange={checked => { this.toggleProfileOption('experienceEnabled', checked); } }
            />
          </div>

          <div className="input-group fifth-width switch-input-group">
            <label>Gender</label>
            <Switch
              id="some-switch"
              checked={genderEnabled || false}
              onChange={checked => { this.toggleProfileOption('genderEnabled', checked); } }
            />
          </div>

        </div>

      </form>
    )
  }

  renderOrganizationOptions(){

    const {
      customGoalsEnabled,
      notificationsPaused,
      forecastingRangeDisabled,
      competenciesEnabled,
    } = this.props.organization || {};

    return (
      <form className="velocity-form" style={{backgroundColor: 'transparent', position: 'relative', float: 'left', clear: 'both', marginTop: '50px', padding: 0}}>

        <div className="form-group">
          <div className="input-group quarter-width switch-input-group">
            <label>Enable custom goal creation</label>
            <Switch
              id="some-switch"
              checked={customGoalsEnabled || false}
              onChange={checked => { this.toggleCustomGoals(); } }
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Pause All Notifications</label>
            <Switch
              id="some-switch"
              checked={notificationsPaused || false}
              onChange={checked => { this.toggleNotificationsPaused(); } }
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Forecasting Range Disabled</label>
            <Switch
              id="some-switch"
              checked={forecastingRangeDisabled || false}
              onChange={checked => { this.toggleForecastingRangeDisabled(); } }
            />
          </div>

          <div className="input-group quarter-width switch-input-group">
            <label>Selling Competencies Activated</label>
            <Switch
              id="some-switch"
              checked={competenciesEnabled || false}
              onChange={checked => { this.toggleCompetenciesEnabled(); } }
            />
          </div>
        </div>

      </form>
    )
  }

  renderLogoUploadContainer(){

    const { logoUrl } = this.props.organization || {};
    const { uploadProgress, uploading } = this.state;

    return (
      <div className="upload-item-container">
        <Dropzone activeClassName='active' acceptClassName='uploading' multiple={false} className="upload-dropzone" onDrop={this.onDrop.bind(this)}>
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps({ className: 'upload-dropzone' })}>
              <input {...getInputProps()} />
              {logoUrl &&
                <img className="upload-item" src={logoUrl} />
              }
              {!logoUrl && !uploading &&
                <p className="no-upload-message">Drag & drop or <span className="action">click here</span> to upload</p>
              }
              {uploading &&
                <div className="upload-progress-container">
                  <div className="upload-progress" style={{width: uploadProgress + '%' }}></div>
                </div>
              }
              {!uploading &&
                <label>Company Logo</label>
              }
            </div>
          )}
        </Dropzone>
      </div>
    );
  }

  onSettingUpdated(){
    this.setState({
      pageMessage: {
        messageType: 'success',
        messageContent: 'Organization settings updated',
        expireAfter: 5000,
      }
    });
  }

  onGoalsUpdated(){
    this.props.endEditingGoals();
    this.setState({
      editingGoal: null,
      pageMessage: {
        messageType: 'success',
        messageContent: 'Organization goals updated',
        expireAfter: 5000,
      }
    });
  }

  organizationGoals(){
    const { sprintGoals } = (this.props.organization || {});

    return sprintGoals || [];
  }

  goalsForCategory(category){
    return _.filter(this.organizationGoals(), goal => {
      return goal.category === category;
    });
  }

  editGoal(goal){

    const { sprintGoals } = (this.props.organization || {});

    console.log('setting editing goal state: ', goal);

    this.setState({
      editingGoal: goal
    }, () => {
      this.props.beginEditingGoals(sprintGoals);
    });
  }

  renderGoal(goal){
    const goalShouldHaveDefinition = goal.category === 'behavior' || goal.category === 'skill';
    const goalHasNonDefaultFrequency = goal.frequency && goal.frequency !== '';
    const goalIsCustom = !!goal.isCustom;

    return(
      <div key={goal.id} className={'goal' + (goal.inactive ? ' inactive' : '')}>
        <div className="goal-name">{goal.name}{goal.inactive ? ' (Inactive)' : ''}</div>
        {goal.description &&
          <div className="goal-description fs-block">Description: {goal.description}</div>
        }
        {goal.items &&
          <div className="goal-description fs-block">Items: {goal.items.join(', ')}</div>
        }
        {goalHasNonDefaultFrequency &&
          <span className="goal-frequency">{goal.frequency}</span>
        }
        {goalIsCustom &&
          <span className="goal-frequency">CUSTOM</span>
        }
        {!goal.inactive && goalShouldHaveDefinition && goal.definition && goal.definition !== '' &&
          <div className="goal-definition">Definition: {goal.definition}</div>
        }
        {!goal.inactive && goalShouldHaveDefinition && (!goal.definition || goal.definition === '') &&
          <button onClick={() => { this.editGoal(goal); }} className="goal-definition-action button primary-outline button-micro">Add talent card definition</button>
        }
      </div>
    )
  }

  quarterOneStartMonthOffsetOptions(){
    return [{
      label: 'January',
      value: 0,
    },{
      label: 'February',
      value: 1,
    },{
      label: 'March',
      value: 2,
    },{
      label: 'April',
      value: 3,
    },{
      label: 'May',
      value: 4,
    },{
      label: 'June',
      value: 5,
    },{
      label: 'July',
      value: 6,
    },{
      label: 'August',
      value: 7,
    },{
      label: 'September',
      value: 8,
    },{
      label: 'October',
      value: 9,
    },{
      label: 'November',
      value: 10,
    },{
      label: 'December',
      value: 11,
    }]
  }

  evaluationPeriodStartOffsetOptions(){
    return [{
      label: 'the week before',
      value: -1
    },{
      label: 'the week of',
      value: 0
    },{
      label: 'the week after',
      value: 1
    }];
  }

  evaluationPeriodDurationOptions(){
    return [{
      label: '1 week',
      value: 1
    },{
      label: '2 weeks',
      value: 2
    },{
      label: '3 weeks',
      value: 3
    },{
      label: '4 weeks',
      value: 4
    }];
  }

  renderGeneralSettings(){
    return (
      <React.Fragment>
        <div className="page-section">
          <div className="section-header">Organzation Options</div>
          {this.renderLogoUploadContainer()}
          {this.renderOrganizationOptions()}
        </div>

        <div className="page-section">
          <div className="section-header">Employee Profile</div>
          {this.renderEmployeeProfileOptions()}
        </div>
        <div className="page-section">
          <div className="section-header">Reporting Options</div>
          {this.renderReportingOptions()}
        </div>
        <div className="page-section">
          <div className="section-header">Disabled Functionality</div>
          {this.renderDisabledFunctionalityOptions()}
        </div>
      </React.Fragment>
    )
  }

  getPageTitle(){
    const { currentView } = this.state;

    switch(currentView){
      default:
      case 'general':
        return 'General Options';
      case 'expertise':
        return 'Manage Critical Expertise';
      case 'goals':
        return 'Manage Sprint Goals';
      case 'calendar':
        return 'Reporting & Evaluation Periods';
      case 'assessmentSetup':
        return 'Talent Assessment Setup';
      case 'assessmentQuestions':
        return 'Manage Assessment Questions';
      case 'integrations':
        return 'Manage App Integrations';
    }
  }

  renderReportingCalendarSettings(){

    let { evaluationPeriodStartOffset, evaluationPeriodDuration, quarterOneStartMonthOffset } = this.props.organization || {};

    evaluationPeriodStartOffset = evaluationPeriodStartOffset || 0;
    evaluationPeriodDuration = evaluationPeriodDuration || 1;
    quarterOneStartMonthOffset = quarterOneStartMonthOffset || 0;

    const reportingAndEvaluationPeriodsForThisYear = getReportingAndEvaluationPeriodsForThisYear();

    return (
      <div className="page-section">
        <p>Each quarter's evaluation period is when weekly velocity sprint reports are paused to give managers and emplyoees time to complete their quarterly evaluation and set up next quarter's goals.</p>
        <div className="evaluation-period-container">
          <p>First Quarter begins in </p>
          <Select
            placeholder="..."
            classNamePrefix={'react-select'}
            className='react-select-container evaluation-period'
            value={getOptionValueForSelect(this.quarterOneStartMonthOffsetOptions(), quarterOneStartMonthOffset)}
            options={this.quarterOneStartMonthOffsetOptions()}
            onChange={(option) => { this.updateOrganizationProp({ quarterOneStartMonthOffset: option.value }); }}
            isSearchable={false}
          />
        <br/>
          <p>Evaluation period begins </p>
            <Select
              placeholder="..."
              classNamePrefix={'react-select'}
              className='react-select-container evaluation-period'
              value={getOptionValueForSelect(this.evaluationPeriodStartOffsetOptions(), evaluationPeriodStartOffset)}
              options={this.evaluationPeriodStartOffsetOptions()}
              onChange={(option) => { this.updateOrganizationProp({ evaluationPeriodStartOffset: option.value }); }}
              isSearchable={false}
            />
          <div className="evaluation-period-divider">the last day the quarter.</div>
          <br/>
          <p>Evaluation period lasts </p>
            <Select
              placeholder="..."
              classNamePrefix={'react-select'}
              className='react-select-container evaluation-period'
              value={getOptionValueForSelect(this.evaluationPeriodDurationOptions(), evaluationPeriodDuration)}
              options={this.evaluationPeriodDurationOptions()}
              onChange={(option) => { this.updateOrganizationProp({ evaluationPeriodDuration: option.value }); }}
              isSearchable={false}
            />
        </div>
        <div>
          <h3 style={{marginBottom: '10px'}}>{getCurrentReportingAndEvaluationYear()} reporting & evaluation periods*</h3>

          {_.map(['1', '2', '3', '4'], quarterNumber => {

            const quarterName = `q${quarterNumber}`;
            const thisQuarter = reportingAndEvaluationPeriodsForThisYear[quarterName];
            const isCurrent = thisQuarter.isCurrent;

            return(
              <div key={`quarter-${quarterNumber}`} className={'reporting-period' + (isCurrent ? ' current' : '')}>
                {isCurrent &&
                  <h6>CURRENT QUARTER ({thisQuarter.status.toUpperCase()})</h6>
                }
                <p>Quarter {quarterNumber} reporting period: <b>{thisQuarter.reportingDates.start.format('M/D/YY')}</b> to <b>{thisQuarter.reportingDates.end.format('M/D/YY')}</b> <small>({thisQuarter.reportingDates.numWeeks} weeks)</small><br/>Quarter {quarterNumber} evaluation period: <b>{thisQuarter.evaluationDates.start.format('M/D/YY')}</b> to <b>{thisQuarter.evaluationDates.end.format('M/D/YY')}</b> <small>({thisQuarter.evaluationDates.numWeeks} {thisQuarter.evaluationDates.numWeeks > 1 ? 'weeks' : 'week'})</small></p>
              </div>
            )
          })}

          <p><small>*Employees are able to complete initial talent evaluation outside of evaluation period</small></p>
        </div>
      </div>
    )
  }

  renderSprintGoalsSettings(){
    return (
      <div className="page-section">
        {this.renderConfigureGoalsButton()}
        <div className="organization-goals">
          {_.map(getFourboxCategories(true, true), category => {
            return (
              <div key={category.key} className="goal-category">
                <div className="goals-section-header">{category.name}</div>
                {category.key === 'competency' &&
                  <React.Fragment>
                    <p style={{opacity: .5}}><small>These goals are automatically added from the AuctusIQ 10 Selling Competencies:</small></p>
                    <p>{_.join(_.map(sellingCompetencies(), 'name'), ', ')}.</p>
                  </React.Fragment>
                }
                {category.key === 'expertise' &&
                  <React.Fragment>
                    <p style={{opacity: .5}}><small>These goals are automatically added from the Critical Expertise configuration:</small></p>
                    <p>{_.join(_.map(this.props.criticalExpertiseItems, 'name'), ', ')}.</p>
                  </React.Fragment>
                }
                {_.map(this.goalsForCategory(category.key), this.renderGoal.bind(this))}
              </div>
            );
          })}
        </div>
      </div>
    )
  }

  renderDeprecatedSprintGoalsSettings(){
    return (
      <div className="page-section">
        {this.renderConfigureGoalsButton()}
        <div className="organization-goals">
          {_.map(getFourboxCategories(false, true), category => {
            return (
              <div key={category.key} className="goal-category">
                <div className="goals-section-header">{category.name}</div>
                {_.map(this.goalsForCategory(category.key), this.renderGoal.bind(this))}
              </div>
            );
          })}
        </div>
      </div>
    )
  }

  updateOrgSetting(newSettings){
    console.log('TODO update org setting: ', newSettings);
  }

  renderAssessmentSetup(){
    return (
      <div className="page-section">
        <AssessmentSetupSection
          orgSettings={this.props.organization}
          updateSettings={updatedSettings => { this.updateOrgSetting(updatedSettings); }}
        />
      </div>
    )
  }

  loadDefaultQuestions(){

  }
  renderAssessmentQuestions(){
    return (
      <div className="page-section">

      </div>
    )
  }

  renderIntegrationsSettings(){
    return <IntegrationsSection
      organization={this.props.organization}
      match={this.props.match}
      updateOrganizationProps={this.updateOrganizationProps.bind(this)}
    />
  }

  renderExpertiseSettings(){
    return <ManageExpertiseSection
      organization={this.props.organization}
      updateOrganizationProps={this.updateOrganizationProps.bind(this)}
    />
  }

  competenciesEnabled(){
    return (this.props.organization || {}).competenciesEnabled;
  }

  render(){

    const { currentView } = this.state;

    const { pageTab } = this.props.match.params;

    if(!pageTab){
      return <Redirect to="/settings/general" />;
    }

    if(!currentUserIsAdmin()){
      return (
        <Page
          pageClass="settings"
          loading={!this.props.organization}
          pageMessage={this.state.pageMessage}
          clearMessage={() => { this.setState({ pageMessage: null }) }}
        >
          <div className="page-title">
            <h1>Settings</h1>
          </div>
          <div className="page-content">
            <div className="page-section">User settings page coming soon.</div>
          </div>
        </Page>
      );
    }

    //<div className="evaluation-period-divider">the last full week of the quarter.</div>

    return (
      <Page
        pageClass="settings"
        customSidebar={<SettingsCustomSidebar />}
        loading={!this.props.organization}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        <div className="page-title">
          <h1>{this.getPageTitle()}</h1>
        </div>
        <div className="page-content">
          {currentView === 'general' && this.renderGeneralSettings()}
          {currentView === 'calendar' && this.renderReportingCalendarSettings()}
          {currentView === 'goals' && this.competenciesEnabled() && this.renderSprintGoalsSettings()}
          {currentView === 'goals' && !this.competenciesEnabled() && this.renderDeprecatedSprintGoalsSettings()}
          {currentView === 'assessmentSetup' && this.renderAssessmentSetup()}
          {currentView === 'assessmentQuestions' && this.renderAssessmentQuestions()}
          {currentView === 'integrations' && this.renderIntegrationsSettings()}
          {currentView === 'expertise' && this.renderExpertiseSettings()}
        </div>
        <UpdateGoalsModal editingGoal={this.state.editingGoal} onSave={this.onGoalsUpdated.bind(this)} />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    organization: state.organization.data,
    criticalExpertiseItems: (state.organization.data || {}).expertiseItems || [],
  }
}

export default connect(mapStateToProps, { beginEditingGoals, endEditingGoals })(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/settings/index.js